import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-module',
  templateUrl: './table-module.component.html',
  styleUrls: ['./table-module.component.css']
})
export class TableModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
